import { render, staticRenderFns } from "./OpenRsvpBlock.vue?vue&type=template&id=30932076"
import script from "./OpenRsvpBlock.vue?vue&type=script&lang=js"
export * from "./OpenRsvpBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports